sidenav=false
swipping=false
fechas = [
	'14/2',
	'15/5',
	'31/10',
	'25/12',
];

$(document).ready(function(){
	$.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content'),
        }
    });
	
	//Menú categorias desplegable
    $('#navProductos').hover(
      function() {
        mostrarCategorias();
      }, function() {
        ocultarCategorias();
      }
    )

    $('#categorias').hover(
      function() {
        $('#categorias').css("display","block");
      }, function() {
        ocultarCategorias();
      }
    )

    function mostrarCategorias(){
      $('#categorias').css({
        "opacity":"0",
        "display":"block",
      }).show().animate({opacity:1});
    }

    function ocultarCategorias(){
      $('#categorias').css("display","none");
    }

    

	$('#canasta .table-responsive').hide()
	$('#btnShowCanasta .indicator').click(function(){
		$('#canasta .table-responsive').slideToggle()
	})
	$('#modalOrden').on('hide.bs.modal', function(){
		$('#modalOrden input:not(#producto_precio, [type=submit])').val('')
		$('#modalOrden select').val('')
		$('#modalOrden span[id]').text('')
		$('#total').text($('#producto_precio').val())
	})
	$('[type=datepicker]').datetimepicker({timepicker:false, format: 'd-m-Y', lang: 'es'})
	$('#sidenavBtn').click(function(){
		if(sidenav){
			$('#sidenavBtn span').removeClass('glyphicon-chevron-left');
			$('#sidenavBtn span').addClass('glyphicon-chevron-right');
			$('.sidenav').animate({left:'-80%'});
			sidenav=false;
		}else{
			$('#sidenavBtn span').removeClass('glyphicon-chevron-right');
			$('#sidenavBtn span').addClass('glyphicon-chevron-left');
			$('.sidenav').animate({left:'0px'});
			sidenav=true;
			swipping=true;
		}
	})
	$(document).bind('touchstart', function(e) {
	    ts = e.originalEvent.touches[0].clientX;
	});

	/*$(document).bind('touchmove', function(e) {
	    var te = e.originalEvent.changedTouches[0].clientX;
	    if (te < ts-50) {
			$('.sidenav').stop().animate({left:'-300px'})
			sidenav=false
	    }
	    if(te > ts+50){
	    	if(typeof($('.table-responsive')[1]) == 'undefined' || (e.target != $('.table-responsive')[1] && !jQuery.contains($('.table-responsive')[1], e.target))){
		        $('.sidenav').stop().animate({left:'0px'})
				sidenav=true
				swipping=true
	    	}
	    }
	});*/
	$(document).click(function(e){
		if(!swipping){
			if(e.target != $('.sidenav')[0] && !jQuery.contains($('.sidenav')[0], e.target)){
				$('.sidenav').animate({left:'-80%'})
				sidenav=false
			}
		}else{
			swipping=false
		}
	})

	//Abrir modal de producto al dar click a un product
	/*
	$('.producto_link').click(function(e){
		e.preventDefault()
		document.cookie="producto="+$(this).attr('href')
		var url=$(this).attr('href')
		$.ajax({
			url: url,
			type:'GET'
		}).done(function(response){
			$('#modalProducto .modal-content').html(response)
			$('#modalProducto').modal('show')
			$('#modalProducto .alert').hide()
		})
	})*/

	curdate=new Date()
	delay=parseInt($('#input-horario').attr('data-delay'))
	if(curdate.getHours()<7){
		//si es que esta pidiendo desde las 00 hasta las 7
		curdate.setHours(6+delay+1)
	}else{
		//si es que esta pidiendo en horario laboral
		curdate.setHours(curdate.getHours()+delay+1)	
	}
	
	//si es que ya sobrepaso al dia actual, se inhabilita las horas
	//del dia actual
	if(curdate.getDay()>new Date().getDay()){
		$('#input-horario').datetimepicker({
			minDate:new Date(),
			minTime:"00:00",
			maxTime:"00:00",
			lang:'es',
			formatDate:'d-m-Y',
			onSelectDate:function(current){
			if(current.getDate() != new Date().getDate() ){
				this.setOptions({minTime: 7+':00',maxTime:"20:30"})
				if (current.getDate() - new Date().getDate() == 1) {
					if(new Date().getHours()+delay > 20){
						this.setOptions({minTime: delay+7+':00'})
					}
				}
			}else{
				this.setOptions({minTime: "00:00",maxTime:"00:00"})
			}
			}
		});
	//si es que no sobrepaso el dia actual
	}else{
		$('#input-horario').datetimepicker({
			minDate:curdate,
			minTime:curdate.getHours()+":00",
			maxTime:"20:30",
			lang:'es',
			formatDate:'d-m-Y',
			onSelectDate:function(current){
				if(fecha_especial(current)){
					$('#envio_horario').addClass("input-warning");
					$('#mensaje_fecha_especial').removeClass('opacity-0');
				}else{
					$('#envio_horario').removeClass("input-warning");
					$('#mensaje_fecha_especial').addClass('opacity-0');
				}
				if(current.getDate() != new Date().getDate() ){
					this.setOptions({minTime: 7+':00'})
					if (current.getDate() - new Date().getDate() == 1) {
						if(new Date().getHours()+delay > 20){
							this.setOptions({minTime: delay+7+':00'})
						}
					}
				}else{
					this.setOptions({minTime: curdate.getHours()+":00"})
				}
			}
		});
	}	
	$('#input-horario').keydown(function(e){
		e.preventDefault()
	})
	$('#register article').hide()
	$('#register .regiones a').click(function(e){
		e.preventDefault()
		$.when($('#register .regiones').slideUp()).done(function(){
			$('#register article').slideDown()
			$('html, body').animate({scrollTop: $('#register article').offset().top+'px'})
			if(innerWidth<520){
				$('#captchaResponsive').css({
					'transform':'scale('+($('#captchaResponsive').siblings('.form-group').width()+6)/$('#captchaResponsive iframe').width()+')',
					'transform-origin':'0 0'
				})
			}else{
				$('#captchaResponsive').css({
					'transform':'scale(1)',
					'transform-origin':'0 0'
				})
			}

			$(window).resize(function(){
				if(innerWidth<520){
					$('#captchaResponsive').css({
						'transform':'scale('+($('#captchaResponsive').siblings('.form-group').width()+6)/$('#captchaResponsive iframe').width()+')',
						'transform-origin':'0 0'
					})
				}else{
					$('#captchaResponsive').css({
						'transform':'scale(1)',
						'transform-origin':'0 0'
					})
				}

			})
		})
	})
})
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
}

function numeroConPuntos(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function fecha_especial(current){
	var fecha = current.getDate()+'/'+(current.getMonth()+1);
	for(var i=0;i<fechas.length;i++){
		if(fecha == fechas[i]){
			return true;
		}
	}
	return false;
}